import { APICompsSchema } from "@unit/apis";
import { addDays, addMonths } from "date-fns";
import { atom } from "jotai";
import { DateRange } from "rsuite/DateRangePicker";

import { InstagramGraphAPIType } from "@/types/FacebookGraphApi";

export const loadingAtom = atom<boolean>(false);
export const idTokenAtom = atom<string | undefined>(undefined);
type AuthUser = APICompsSchema["StaffObject"] | null;
/** お知らせは店舗非依存。TOP外でのログアウトも同期的にセッションを区切る。 */
export const noticeSessionAtom = atom(0);
export const importantNoticeShownAtom = atom(false);
// primitiveのinitを維持し、既存のProvider/useHydrateAtomsとの互換性を保つ。
export const authUserAtom = atom<AuthUser>(null);
authUserAtom.write = (get, set, update) => {
  const previous = get(authUserAtom);
  const next = typeof update === "function" ? update(previous) : update;
  if (previous?.id !== next?.id) {
    set(noticeSessionAtom, get(noticeSessionAtom) + 1);
    set(importantNoticeShownAtom, false);
  }
  set(authUserAtom, next);
};
export const selectStoreAtom = atom<APICompsSchema["FlatStoreObject"] | null>(null);
export const genresAtom = atom<APICompsSchema["FlatGenreObject"][] | null>(null);
export const areasAtom = atom<APICompsSchema["FlatAreaObject"][] | null>(null);
export const ticketFormChangedAtom = atom<"new" | "edit" | null>(null);
export const instagramAccountsForAuthAtom = atom<InstagramGraphAPIType[]>([]);

export const storesInfluencerTicketStatusesAtom = atom<
  {
    id: string;
    influencer_ticket_statuses: {
      media: {
        name?: APICompsSchema["InfluencerTicketStatusEnum"];
        count?: APICompsSchema["CountValue"];
      }[];
      influencer: {
        name?: APICompsSchema["InfluencerTicketStatusEnum"];
        count?: APICompsSchema["CountValue"];
      }[];
    }[];
  }[]
>([]);

export const selectedTicketsAtom = atom<APICompsSchema["TicketObject"][]>([]);
export const selectTicketObjForOfferAtom = atom<APICompsSchema["TicketObject"] | null>(null);

export const selectInfluencerTicketIdAtom = atom<{
  chatOpen: boolean;
  influencerTicketId: string;
}>({
  chatOpen: false,
  influencerTicketId: "",
});

export const pageTitleAtom = atom<string>("");
export const dateRangeAtom = atom<DateRange>([addDays(addMonths(new Date(), -1), -1), addDays(new Date(), -1)]);

export const CustomMUIDataTableStateAtom = atom<{
  offset: number;
  limit: number;
  sortBy: string;
  keyword?: string;
}>({ offset: 0, limit: 25, sortBy: "updatedAt-desc" });

export const CustomMUIDataTablePageAtom = atom<{
  page: number;
  rowsPerPage: number;
}>({ page: 0, rowsPerPage: 25 });
